/**
 * True only when the app is running under `nuxi dev`.
 *
 * Nuxt injects `import.meta.dev` at build time. Vitest does not, and a
 * module's `import.meta` cannot be mutated from another module — so a
 * dev-only branch reading it inline is permanently false under test, and a
 * test could only ever assert the "hidden" half. That is too weak for a gate
 * whose failure mode is leaking developer tooling onto a client-facing page:
 * a TYPO'd flag (`import.meta.devv`) is also permanently false and would pass
 * the same assertion.
 *
 * Wrapping the read in this function gives tests a seam to drive BOTH
 * directions (`vi.mock`), so "hidden in production" and "shown in dev" are
 * each pinned.
 */
export function isDevMode(): boolean {
  return import.meta.dev === true
}
